import React from "react";
import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { BASE_URL } from "../State/Interceptor/Url";

export const DataPreviewComponent = ({
  modalState,
  changeModalState,
  action,
  name,
  dob,
  spouse,
  spouseDob,
  aniversaryAt,
  children,
  photo,
  familyPhoto,
  occupation,
  businessWebLink,
  homeAddress,
  primaryContact,
  secondaryContact,
  emailId,
  officeAddress,
  state,
  city,
  zone,
  business,
}) => {
  const cancelButtonRef = useRef(null);

  const InputComponent = ({ txt, content }) => {
    return (
      <div className="relative mb-4 flex w-full flex-wrap items-stretch">
        <span
          className="flex w-40 items-center whitespace-nowrap rounded-l border border-r-0 border-solid border-neutral-300 px-3 py-[0.25rem] text-center text-base font-normal leading-[1.6] text-neutral-700 bg-gray-200"
          id="basic-addon1"
        >
          {txt}
        </span>
        <input
          type="text"
          disabled
          defaultValue={content}
          className="relative m-0 block w-[1px] min-w-0 flex-auto rounded-r border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-neutral-700 outline-none transition ease-in-out focus:z-[3] focus:border-primary-600 focus:text-neutral-700 focus:shadow-te-primary focus:outline-none "
          placeholder={txt}
          aria-label={txt}
          aria-describedby="basic-addon1"
        />
      </div>
    );
  };
  const ImageComponent = ({ txt, image }) => {
    return (
      <div className="relative mb-4 flex w-full flex-wrap items-stretch">
        <span
          className="flex w-40 items-center whitespace-nowrap rounded-l border border-r-0 border-solid border-neutral-300 px-3 py-[0.25rem] text-center text-base font-normal leading-[1.6] text-neutral-700 bg-gray-200"
          id="basic-addon1"
        >
          {txt}
        </span>
        <img
          src={
            image
              ? image.startsWith("blob")
                ? image
                : BASE_URL + "file/" + image
              : "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Image_not_available.png/640px-Image_not_available.png"
          }
          alt="Not Found"
          className="h-24 w-24 object-contain"
        />
      </div>
    );
  };

  return (
    <div>
      <Transition.Root show={modalState} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => changeModalState(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-11/12 sm:w-10/12">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-2xl font-semibold leading-6 text-gray-900"
                        >
                          Preview
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want to submit data?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="p-5">
                    <InputComponent txt={"Name"} content={name} />
                    <InputComponent txt={"D.O.B."} content={dob} />
                    {/* <InputComponent txt={"Spouse"} content={spouse} />
                    <InputComponent txt={"Spouse D.O.B."} content={spouseDob} />
                    <InputComponent txt={"Aniversary"} content={aniversaryAt} />
                    <InputComponent txt={"Children"} content={children} /> */}
                    <ImageComponent txt={"Photo"} image={photo} />
                    <ImageComponent txt={"Family Photo"} image={familyPhoto} />

                    <InputComponent txt={"Occupation"} content={occupation} />
                    {/* <InputComponent
                      txt={"Business Link"}
                      content={businessWebLink}
                    /> */}
                    <InputComponent txt={"Address"} content={homeAddress} />
                    <InputComponent
                      txt={"Primary Contact"}
                      content={primaryContact}
                    />
                    {/* <InputComponent
                      txt={"Secondary Contact"}
                      content={secondaryContact}
                    /> */}
                    <InputComponent txt={"Email ID"} content={emailId} />
                    {/* <InputComponent txt={"Off. Add."} content={officeAddress} /> */}
                    <InputComponent txt={"State"} content={state} />
                    <InputComponent txt={"City"} content={city} />
                    <InputComponent txt={"Zone"} content={zone} />
                    {business.map((item, index) => {
                      return (
                        <InputComponent
                          key={index}
                          txt={"Business " + (index + 1)}
                          content={item.bname}
                        />
                      );
                    })}
                  </div>

                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm bg-[#5c33ae] hover:bg-[#2f0e70] sm:ml-3 sm:w-auto"
                      onClick={() => {
                        action();
                        changeModalState(false);
                      }}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => changeModalState(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};
